import { LanguageIsoCode } from '@/graphql/graphql';
import { GET_CATEGORIES } from '@/graphql/queries/categories.graphql';
import { apolloClient } from './apollo-client';

export type FetchCategoriesListArgs = {
    language: LanguageIsoCode;
};
export async function fetchCategoriesList({ language = LanguageIsoCode.En }: FetchCategoriesListArgs) {
    const response = await apolloClient.query({ query: GET_CATEGORIES, variables: { language: language } });

    return { data: response.data.categories, total: response.data.categories.length };
}
